import React, { useContext, useEffect, useMemo, useState } from "react";
import DataContext from "./DataContext";
import TextInput from "../Components/Field_Component/TextInput";
import SelectInput from "../Components/Field_Component/SelectInput";
import NationalityList from "../utils/NationalitiesList.json";
import Certificate from "../utils/Certificate.json";
import Branch from "../utils/Branch.json";

import Religion from "../utils/Religion.json";
import Institute from "../utils/Institute.json";
import IndustryList from "../utils/IndustryList.json";
import getURLS from "../utils/helper";

import { toast } from "react-toastify";
import axios from "axios";
import { getAge } from "../utils/handlerFunction";
import { capitalize } from "@mui/material";
import DateInput from "../Components/Field_Component/DateField";
import { useNavigate } from "react-router";

function DataProvider( { children } ) {
  const [ token, setToken ] = useState( "" );
  const [ multipleData, setMultipleData ] = useState( {} );
  const [ otpFieldVisible, setOtpFieldVisible ] = useState( false );
  const [ userGender, setUserGender ] = useState( "2" );
  const navigate = useNavigate();

  const [ fieldValues, setFieldValues ] = useState( {
    AADHAR_NUMBER: "",
    PAN_CARD: "",
    SUB_DATE: "",
    LICENCE_TYPE: "",
    DRIVING_LICENCE: "",
    MOB_NO: "",
    ALTERNATE_MOB: "",
    EMAIL: "",
    FIRST_NAME: "",
    LAST_NAME: "",
    GENDER: "",
    BLOOD_GROUP: "",
    CATEGORY: "",
    DOB: "",
    BNK_CON_ACCNT_NO: "",
    ADDRESS: "",
    PLACE: "",
    TALUKA: "",
    STATE: "",
    COUNTRY: "",
    PIN_CODE: "",
    NATIONALITY: "IN",
    MARITAL_STATUS: "",
    MARRIAGE_DATE: "",
    SPOUSE_NAME: "",
    SPOUSE_GENDER: "",
    SPOUSE_DOB: "",
    RELIGION: "",
    QUALIFICATION: "",
    EDUCATION: "",
    EDU_START_DATE: "",
    EDU_END_DATE: "",
    EDU_COUNTRY: "",
    EDU_CERTIFICATE: "",
    EDU_FINAL_GRADE: "",
    EDU_BRANCH: "",
    EDU_PERCENTAGE: "",
    EDU_TYPE: "",
    EDU_INSTITUTE: "",
    EMPLOYER: "",
    EMPLOYER_CITY: "",
    EMPLOYER_COUNTRY: "",
    EMPLOYER_INDUSTRY: "",
    EMPLOYER_START_DATE: "",
    EMPLOYER_END_DATE: "",
    EMPLOYEE_JOB: "",
    WORK_CONTRACT: "",
    ANNUAL_SALARY: "",
    CURRENCY: "",
    EXPERIENCE_TYPE: "",
    JOB_ROLE: "",
    JOB: "",
    BNK_ACCNT_NO: "",
    BNK_ACCNT_PAYEE: "",
    BNK_POSTAL_CODE: "",
    BNK_CITY: "",
    BNK_RECEIPENT_COUNTRY: "",
    BNK_COUNTRY: "",
    BNK_PAY_METHOD: "",
    PURPOSE: "",
    BNK_PAY_CURRENCY: "",
    BNK_NAME: "",
    IFSC: "",
    BNK_ACC_HOL_NAME: "",
    BNK_CON_ACCNT_NO: "",
    EMPLOYER_COUNTRY: "",
    MIDDLE_NAME: "",
  } );

  const filterNationalityList = NationalityList.map( ( val, index ) => {
    return { id: index + 1, title: val?.nationality, value: val?.alpha_2_code };
  } );

  const ReligionList = Religion?.map( ( religion, index ) => {
    return { id: index + 1, title: religion?.label, value: religion?.id };
  } );

  const IndList = IndustryList?.map( ( ind, index ) => {
    return { id: index + 1, title: ind?.Industry_Key, value: ind?.Industry };
  } );

  const handleDynamicDates = ( value, id, rowId, name, sectionTitle ) => {
    if ( sectionTitle === "Education Details" ) {
      if ( name === "EDU_START_DATE" ) {
        EducationList[ rowId - 1 ].array[ id - 1 ].error = undefined;
        EducationList[ rowId - 1 ].array[ id - 1 ].value = value
      }
      if ( name === "EDU_END_DATE" ) {
        EducationList[ rowId - 1 ].array[ id - 1 ].error = undefined;
        EducationList[ rowId - 1 ].array[ id - 1 ].value = value
      }
    }

    if ( sectionTitle === "Previous Employer Details" ) {
      if ( name === "EMPLOYER_START_DATE" ) {
        EmployerList[ rowId - 1 ].array[ id - 1 ].error = undefined;
        EmployerList[ rowId - 1 ].array[ id - 1 ].value = value
      }
      if ( name === "EMPLOYER_END_DATE" ) {
        EmployerList[ rowId - 1 ].array[ id - 1 ].error = undefined;
        EmployerList[ rowId - 1 ].array[ id - 1 ].value = value
      }
    }



    console.log( value, id, rowId, name, sectionTitle );
    console.log( EducationList )
    console.log( EmployerList )

  };


  const handleGetdates = ( name, value ) => {
    if ( name === "DOB" ) {
      if ( value ) {
        if ( getAge( value ) >= 18 ) {
          setErrors( ( prev ) => ( {
            ...prev,
            DOB: { errorText: "", errorValue: false },
          } ) );
        } else {
          setErrors( ( prev ) => ( {
            ...prev,
            DOB: {
              errorText: "DOB should be 18 years and above",
              errorValue: true,
            },
          } ) );
        }
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          DOB: {
            errorText: "",
            errorValue: false,
          },
        } ) );
      }
    }

    if ( name === "SPOUSE_DOB" ) {
      if ( value ) {
        if ( getAge( value ) >= 18 ) {
          setErrors( ( prev ) => ( {
            ...prev,
            SPOUSE_DOB: { errorText: "", errorValue: false },
          } ) );
        } else {
          setErrors( ( prev ) => ( {
            ...prev,
            SPOUSE_DOB: {
              errorText: "Spouse date should be 18 years and above",
              errorValue: true,
            },
          } ) );
        }
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          SPOUSE_DOB: {
            errorText: "",
            errorValue: false,
          },
        } ) );
      }
    }


    setFieldValues( {
      ...fieldValues,
      [ name ]: value,
    } );
  };


  const [ errors, setErrors ] = useState( {
    AADHAR_NUMBER: { errorText: '""', errorValue: false },
    PAN_CARD: { errorText: "", errorValue: false },
    SUB_DATE: { errorText: "", errorValue: false },
    LICENCE_TYPE: { errorText: "", errorValue: false },
    DRIVING_LICENCE: { errorText: "", errorValue: false },
    MOB_NO: { errorText: "", errorValue: false },
    ALTERNATE_MOB: { errorText: "", errorValue: false },
    EMAIL: { errorText: "", errorValue: false },
    FIRST_NAME: { errorText: "", errorValue: false },
    LAST_NAME: { errorText: "", errorValue: false },
    GENDER: { errorText: "", errorValue: false },
    BLOOD_GROUP: { errorText: "", errorValue: false },
    CATEGORY: { errorText: "", errorValue: false },
    DOB: { errorText: "", errorValue: false },
    ADDRESS: { errorText: "", errorValue: false },
    PLACE: { errorText: "", errorValue: false },
    TALUKA: { errorText: "", errorValue: false },
    STATE: { errorText: "", errorValue: false },
    COUNTRY: { errorText: "", errorValue: false },
    PIN_CODE: { errorText: "", errorValue: false },
    NATIONALITY: { errorText: "", errorValue: false },
    MARITAL_STATUS: { errorText: "", errorValue: false },
    MARRIAGE_DATE: { errorText: "", errorValue: false },
    SPOUSE_NAME: { errorText: "", errorValue: false },
    SPOUSE_GENDER: { errorText: "", errorValue: false },
    SPOUSE_DOB: { errorText: "", errorValue: false },
    RELIGION: { errorText: "", errorValue: false },
    QUALIFICATION: { errorText: "", errorValue: false },
    EDUCATION: { errorText: "", errorValue: false },
    EDU_START_DATE: { errorText: "", errorValue: false },
    EDU_END_DATE: { errorText: "", errorValue: false },
    EDU_COUNTRY: { errorText: "", errorValue: false },
    EDU_CERTIFICATE: { errorText: "", errorValue: false },
    EDU_FINAL_GRADE: { errorText: "", errorValue: false },
    EDU_BRANCH: { errorText: "", errorValue: false },
    EDU_PERCENTAGE: { errorText: "", errorValue: false },
    EDU_TYPE: { errorText: "", errorValue: false },
    EDU_INSTITUTE: { errorText: "", errorValue: false },
    EDU_OTH_INSTITUTE: { errorText: "", errorValue: false },
    EMPLOYER: { errorText: "", errorValue: false },
    EMPLOYER_CITY: { errorText: "", errorValue: false },
    EMPLOYER_COUNTRY: { errorText: "", errorValue: false },
    EMPLOYER_INDUSTRY: { errorText: "", errorValue: false },
    EMPLOYEE_JOB: { errorText: "", errorValue: false },
    EMPLOYER_START_DATE: { errorText: "", errorValue: false },
    EMPLOYER_END_DATE: { errorText: "", errorValue: false },
    WORK_CONTRACT: { errorText: "", errorValue: false },
    ANNUAL_SALARY: { errorText: "", errorValue: false },
    CURRENCY: { errorText: "", errorValue: false },
    EXPERIENCE_TYPE: { errorText: "", errorValue: false },
    JOB_ROLE: { errorText: "", errorValue: false },
    JOB: { errorText: "", errorValue: false },
    BNK_ACCNT_NO: { errorText: "", errorValue: false },
    BNK_CON_ACCNT_NO: { errorText: "", errorValue: false },
    BNK_ACCNT_PAYEE: { errorText: "", errorValue: false },
    BNK_POSTAL_CODE: { errorText: "", errorValue: false },
    BNK_RECEIPENT_COUNTRY: { errorText: "", errorValue: false },
    BNK_COUNTRY: { errorText: "", errorValue: false },
    BNK_PAY_METHOD: { errorText: "", errorValue: false },
    PURPOSE: { errorText: "", errorValue: false },
    BNK_PAY_CURRENCY: { errorText: "", errorValue: false },
    BNK_NAME: { errorText: "", errorValue: false },
    IFSC: { errorText: "", errorValue: false },
    BNK_ACC_HOL_NAME: { errorText: "", errorValue: false },
    BNK_CON_ACCNT_NO: { errorText: "", errorValue: false },
    BNK_CITY: { errorText: "", errorValue: false },
    EMPLOYER_COUNTRY: { errorText: "", errorValue: false },
    MIDDLE_NAME: { errorText: "", errorValue: false },
  } );

  const [ errorChange, setErrorChange ] = useState( { value: "", name: "" } );
  const [ timeLeft, setTimeLeft ] = useState( 0 );
  const [ canResend, setCanResend ] = useState( false );
  const [ maritalStatus, setMaritalStatus ] = useState( 1 );
  const [ submitLoading, setSubmitLoading ] = useState( false );
  const [ addInst, setAddInst ] = useState( false );
  const [ EmployerList, setEmployerList ] = useState( [
    {
      id: 1,
      array: [
        {
          id: 1,
          title: "Employer",
          name: "EMPLOYER",
          value: undefined,
          type: "text",
          required: false,
          // handleFunction: handleGetInputs,
          Component: TextInput,
          error: errors?.EMPLOYER.errorValue,
          errorText: errors?.EMPLOYER.errorText,
        },
        {
          id: 2,
          title: "City",
          name: "EMPLOYER_CITY",
          value: undefined,
          type: "text",
          required: false,
          // handleFunction: handleGetInputs,
          Component: TextInput,
          error: errors?.EMPLOYER_CITY.errorValue,
          errorText: errors?.EMPLOYER_CITY.errorText,
        },
        // {
        //   id: 3,
        //   title: "Country",
        //   name: "EMPLOYER_COUNTRY",
        //   value: undefined,
        //   type: "select",
        //   required: false,
        //   // handleFunction: handleGetInputs,
        //   options: [{ id: 1, title: "India", value: "IN" }],
        //   Component: SelectInput,
        //   error: errors?.EMPLOYER_COUNTRY.errorValue,
        //   errorText: errors?.EMPLOYER_COUNTRY.errorText,
        // },
        {
          id: 3,
          title: "Industry",
          name: "EMPLOYER_INDUSTRY",
          value: undefined,
          type: "select",
          required: false,
          // handleFunction: handleGetInputs,
          options: IndList,
          Component: SelectInput,
          error: errors?.EMPLOYER_INDUSTRY.errorValue,
          errorText: errors?.EMPLOYER_INDUSTRY.errorText,
        },
        {
          id: 4,
          title: "Job",
          name: "JOB",
          value: undefined,
          type: "text",
          required: false,
          // handleFunction: handleGetInputs,
          Component: TextInput,
          error: errors?.JOB.errorValue,
          errorText: errors?.JOB.errorText,
        },
        {
          id: 5,
          title: "Work Contract",
          name: "WORK_CONTRACT",
          value: undefined,
          type: "number",
          required: false,
          // handleFunction: handleGetInputs,
          Component: TextInput,
          error: errors?.WORK_CONTRACT.errorValue,
          errorText: errors?.WORK_CONTRACT.errorText,
          endIcon: "years",
        },
        {
          id: 6,
          title: "Annual gross salary",
          name: "ANNUAL_SALARY",
          value: undefined,
          type: "number",
          required: false,
          // handleFunction: handleGetInputs,
          Component: TextInput,
          error: errors?.ANNUAL_SALARY.errorValue,
          errorText: errors?.ANNUAL_SALARY.errorText,
        },
        // {
        //   id: 8,
        //   title: "Currency",
        //   name: "CURRENCY",
        //   value: undefined,
        //   type: "text",
        //   required: false,
        //   // handleFunction: handleGetInputs,
        //   Component: TextInput,
        //   error: errors?.CURRENCY,
        //   errorText: "",
        // },
        {
          id: 7,
          title: "Experience type",
          name: "EXPERIENCE_TYPE",
          value: undefined,
          type: "select",
          required: false,
          options: [
            { id: 1, title: "Relevant", value: "1" },
            { id: 2, title: "Irrelevant", value: "" },
          ],
          // handleFunction: handleGetInputs,
          Component: SelectInput,
          error: errors?.EXPERIENCE_TYPE.errorValue,
          errorText: errors?.EXPERIENCE_TYPE.errorText,
        },
        {
          id: 8,
          title: "Role",
          name: "JOB_ROLE",
          value: undefined,
          type: "text",
          required: false,
          // handleFunction: handleGetInputs,
          Component: TextInput,
          error: errors?.JOB_ROLE.errorValue,
          errorText: errors?.JOB_ROLE.errorText,
        },
        {
          id: 9,
          title: "Start Date",
          name: "EMPLOYER_START_DATE",
          value: undefined,
          type: "date",
          required: false,
          // handleFunction: handleGetInputs,
          Component: DateInput,
          dynamicDate: true,
          error: errors?.EMPLOYER_START_DATE.errorValue,
          errorText: errors?.EMPLOYER_START_DATE.errorText,
        },
        {
          id: 10,
          title: "End Date",
          name: "EMPLOYER_END_DATE",
          value: undefined,
          type: "date",
          required: false,
          // handleFunction: handleGetInputs,
          Component: DateInput,
          dynamicDate: true,
          error: errors?.EMPLOYER_END_DATE.errorValue,
          errorText: errors?.EMPLOYER_END_DATE.errorText,
        },
      ],
    },
  ] );
  const [ EducationList, setEducationList ] = useState( [
    {
      id: 1,
      array: [
        {
          id: 1,
          title: "Education",
          name: "EDUCATION",
          value: undefined,
          options: [
            {
              id: 1,
              title: "High School",
              value: "01",
            },
            {
              id: 2,
              title: "Higher Secondary Sch",
              value: "02",
            },
            {
              id: 3,
              title: "ITI",
              value: "03",
            },
            {
              id: 4,
              title: "Diploma",
              value: "04",
            },
            {
              id: 5,
              title: "Graduation",
              value: "05",
            },
            {
              id: 6,
              title: "Professional Degree",
              value: "06",
            },
            {
              id: 7,
              title: "Post Graduation",
              value: "07",
            },
            {
              id: 8,
              title: "PG Diploma",
              value: "08",
            },
            {
              id: 9,
              title: "Professional Certification",
              value: "09",
            },
            {
              id: 10,
              title: "Doctoral Certification",
              value: "10",
            },
            {
              id: 11,
              title: "Post Diploma",
              value: "11",
            },
          ],
          type: "select",
          required: true,
          // handleFunction: handleSelectInputs,
          Component: SelectInput,
          error: errors?.EDUCATION.errorValue,
          errorText: errors.EDUCATION.errorText,
        },
        {
          id: 2,
          title: "Certificate",
          name: "EDU_CERTIFICATE",
          value: undefined,
          type: "select",
          required: true,
          options: [],
          // handleFunction: handleGetInputs,
          Component: SelectInput,
          error: errors?.EDU_CERTIFICATE.errorValue,
          errorText: errors.EDU_CERTIFICATE.errorText,
        },
        // {
        //   id: 3,
        //   title: "Education Country",
        //   name: "EDU_COUNTRY",
        //   value: undefined,
        //   type: "select",
        //   required: true,
        //   options: [{ id: 1, title: "India", value: "IN" }],
        //   // handleFunction: handleGetInputs,
        //   Component: SelectInput,
        //   error: errors?.EDU_COUNTRY.errorValue,
        //   errorText: errors.EDU_COUNTRY.errorText,
        // },

        {
          id: 3,
          title: "Final Grade",
          name: "EDU_FINAL_GRADE",
          value: undefined,
          type: "select",
          required: false,
          // handleFunction: handleGetInputs,
          options: [
            { id: 1, title: "A+", value: "A+" },
            { id: 2, title: "A", value: "A" },
            { id: 3, title: "A-", value: "A-" },
            { id: 4, title: "B+", value: "B+" },
            { id: 5, title: "B", value: "B" },
            { id: 6, title: "B-", value: "B-" },
            { id: 7, title: "C+", value: "C+" },
            { id: 8, title: "C", value: "C" },
            { id: 9, title: "C-", value: "C-" },
            { id: 10, title: "D+", value: "D+" },
            { id: 11, title: "D", value: "D" },
            { id: 12, title: "D-", value: "D-" },
            { id: 13, title: "F", value: "F" },
          ],
          Component: SelectInput,
          error: errors?.EDU_FINAL_GRADE.errorValue,
          errorText: errors.EDU_FINAL_GRADE.errorText,
        },
        {
          id: 4,
          title: "Institute",
          name: "EDU_INSTITUTE",
          value: undefined,
          type: "select",
          required: true,
          options: Institute?.map( ( val ) => {
            return { title: val?._2, value: val?._1 };
          } ),
          // handleFunction: handleGetInputs,
          Component: SelectInput,
          error: errors?.EDU_INSTITUTE.errorValue,
          errorText: errors.EDU_INSTITUTE.errorText,
        },
        {
          id: 5,
          title: "Other Institute Name(optional)",
          name: "EDU_OTH_INSTITUTE",
          value: undefined,
          type: "text",
          required: false,
          disabled: addInst,
          handleFunction: handleGetInputs,
          Component: TextInput,
          error: errors?.EDU_OTH_INSTITUTE.errorValue,
          errorText: errors.EDU_OTH_INSTITUTE.errorText,
        },
        {
      id: 6,
      title: "Branch of Study/Trade",
      name: "EDU_BRANCH",
      value: undefined,
      type: "select",
      required: false,
       options: [],
      // handleFunction: handleGetInputs,
      Component: SelectInput,
      error: errors?.EDU_BRANCH.errorValue,
      errorText: errors?.EDU_BRANCH.errorText,
    },
        {
          id: 7,
          title: "Percentage of Marks",
          name: "EDU_PERCENTAGE",
          value: undefined,
          type: "number",
          required: false,
          // handleFunction: handleGetInputs,
          Component: TextInput,
          endIcon: "%",
          error: errors?.EDU_PERCENTAGE.errorValue,
          errorText: errors?.EDU_PERCENTAGE.errorText,
        },
        {
          id: 8,
          title: "Education type",
          name: "EDU_TYPE",
          value: undefined,
          type: "select",
          options: [
            {
              id: 1,
              title: "Full time",
              value: "1",
            },
            {
              id: 2,
              title: "Part time",
              value: "2",
            },
          ],
          required: false,
          // handleFunction: handleSelectInputs,
          Component: SelectInput,
          error: errors?.EDU_TYPE.errorValue,
          errorText: errors.EDU_TYPE.errorText,
        },

        {
          id: 9,
          title: "Start Date",
          name: "EDU_START_DATE",
          value: undefined,
          type: "date",
          required: false,
          // handleFunction: handleGetInputs,
          Component: DateInput,
          dynamicDate: true,
          error: errors?.EDU_START_DATE.errorValue,
          errorText: errors.EDU_START_DATE.errorText,
        },
        {
          id: 9,
          title: "End Date",
          name: "EDU_END_DATE",
          value: undefined,
          type: "date",
          required: false,
          // handleFunction: handleGetInputs,
          Component: DateInput,
          dynamicDate: true,
          error: errors?.EDU_END_DATE.errorValue,
          errorText: errors.EDU_END_DATE.errorText,
        },
      ],
    },
  ] );

  useMemo( () => {

    console.log( 'education', EducationList )
  }, [ EducationList ] )


  const validateField = ( name, value ) => {
    const errorsMap = {
      PIN_CODE: () => {
        if ( !value || value.length === 6 ) {
          return { errorText: " ", errorValue: false };
        }
        return { errorText: "Invalid Pin Code", errorValue: true };
      },

      BNK_POSTAL_CODE: () => {
        if ( !value || value?.length === 6 ) {
          return { errorText: " ", errorValue: false };
        }
        return {
          errorText: "Invalid Pincode",
          errorValue: true,
        };
      },
    };

    if ( errorsMap[ name ] ) {
      setErrors( ( prev ) => ( {
        ...prev,
        [ name ]: errorsMap[ name ](),
      } ) );
    }
  };

  // handle onchange function to get all fields values

  const handleGetMultipleInputs = ( e, rowId, id, sectionTitle ) => {
    const { value, name } = e.target;
    // console.log(value, name, e, rowId, id, sectionTitle);
    if ( name === "EMPLOYER_START_DATE" ) {
      const today = new Date().getTime(); // Get today's date
      // console.log("todaytoday", today);
      const inputStartDate = new Date( value ).getTime(); // Convert input value to a Date object

      if ( inputStartDate > today ) {
        EmployerList[ rowId - 1 ].array[ id - 1 ].error = true;
        EmployerList[ rowId - 1 ].array[ id - 1 ].errorText =
          "Start date cannot be future date";

        // EmployerList[rowId - 1].array[id - 1].value = values?.value;
      } else {
        EmployerList[ rowId - 1 ].array[ id - 1 ].error = false;
        EmployerList[ rowId - 1 ].array[ id - 1 ].errorText = "";
      }
    }

    if ( name === "EMPLOYER_END_DATE" ) {
      const today = new Date().getTime(); // Get today's date
      // console.log("todaytoday", today);
      const inputEndDate = new Date( value ).getTime(); // Convert input value to a Date object

      if ( inputEndDate > today ) {
        EmployerList[ rowId - 1 ].array[ id - 1 ].error = true;
        EmployerList[ rowId - 1 ].array[ id - 1 ].errorText =
          "End date cannot be future date";

        // EmployerList[rowId - 1].array[id - 1].value = values?.value;
      } else {
        EmployerList[ rowId - 1 ].array[ id - 1 ].error = false;
        EmployerList[ rowId - 1 ].array[ id - 1 ].errorText = "";
      }
    }

    if ( name === "EDU_START_DATE" ) {
      const today = new Date().getTime(); // Get today's date
      // console.log("todaytoday", today);
      const inputEndDate = new Date( value ).getTime(); // Convert input value to a Date object

      if ( inputEndDate > today ) {
        EducationList[ rowId - 1 ].array[ id - 1 ].error = true;
        EducationList[ rowId - 1 ].array[ id - 1 ].errorText =
          "Start date cannot be future date";

        // EmployerList[rowId - 1].array[id - 1].value = values?.value;
      } else {
        EducationList[ rowId - 1 ].array[ id - 1 ].error = false;
        EducationList[ rowId - 1 ].array[ id - 1 ].errorText = "";
      }
    }

    if ( name === "EDU_END_DATE" ) {
      const today = new Date().getTime(); // Get today's date
      // console.log("todaytoday", today);
      const inputEndDate = new Date( value ).getTime(); // Convert input value to a Date object

      if ( inputEndDate > today ) {
        EducationList[ rowId - 1 ].array[ id - 1 ].error = true;
        EducationList[ rowId - 1 ].array[ id - 1 ].errorText =
          "End date cannot be future date";

        // EmployerList[rowId - 1].array[id - 1].value = values?.value;
      } else {
        EducationList[ rowId - 1 ].array[ id - 1 ].error = false;
        EducationList[ rowId - 1 ].array[ id - 1 ].errorText = "";
      }
    }

    if ( name === "EDU_PERCENTAGE" ) {
      if ( value?.length > 2 ) {
        setErrors( ( prev ) => ( { ...prev, EDU_PERCENTAGE: true } ) );
      } else {
        setErrors( ( prev ) => ( { ...prev, EDU_PERCENTAGE: false } ) );
      }
    }

    if ( sectionTitle === "Education Details" ) {
      setEducationList( ( prevList ) => {
        const updatedList = [ ...prevList ];
        const updatedRow = { ...updatedList[ rowId - 1 ] };
        updatedRow.array = [ ...updatedRow.array ];
        updatedRow.array[ id - 1 ] = { ...updatedRow.array[ id - 1 ], value };
        updatedList[ rowId - 1 ] = updatedRow;
        return updatedList;
      } );
    } else {
      setEmployerList( ( prevList ) => {
        const updatedList = [ ...prevList ];
        const updatedRow = { ...updatedList[ rowId - 1 ] };
        updatedRow.array = [ ...updatedRow.array ];
        updatedRow.array[ id - 1 ] = { ...updatedRow.array[ id - 1 ], value };

        updatedList[ rowId - 1 ] = updatedRow;
        return updatedList;
      } );
    }
  };

  // submit button will enable and disable according to this
  const enableError = Object.values( errors ).some(
    ( val ) => val.errorValue === true
  );

  useMemo( () => {
    const { value, name } = errorChange;
    const newValue = value?.replace(/\s/g, '');

    // validation Aadhar card

    // if (name === "AADHAR_NUMBER") {
    //   if (value.length === 12 || value?.length === 0) {
    //     setErrors((prev) => ({ ...prev, AADHAR_NUMBER: false }));
    //   } else {
    //     setErrors((prev) => ({ ...prev, AADHAR_NUMBER: true }));
    //   }
    // }

    // validation alternate mob

   

    // validation Driving licence

    // if (name === "DRIVING_LICENCE") {
    //   if (!Driving_regexp.test(value)) {
    //     setErrors((prev) => ({ ...prev, DRIVING_LICENCE: true }));
    //   } else {
    //     setErrors((prev) => ({ ...prev, DRIVING_LICENCE: false }));
    //   }
    // }

    // validation Pan card

    if ( name === "PAN_CARD" ) {
      if ( !value ) {
        setErrors( ( prev ) => ( { ...prev, PAN_CARD: false } ) );
      }
    }

    // validation Email

    if ( name === "EMAIL" ) {
      if ( !value ) {
        setErrors( ( prev ) => ( { ...prev, EMAIL: false } ) );
      }
    }
  }, [ errorChange ] );

  var handleGetInputs = ( e ) => {
    const { value, name } = e.target;
    const newValue = value.replace(/\s/g, '');

    const Ifsc = /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/;
    const PAN_regexp =
      /^([a-zA-Z][a-zA-Z][a-zA-Z][a-zA-Z][a-zA-Z][0-9][0-9][0-9][0-9][a-zA-Z])?$/;

    const Driving_regexp =
      /^([a-zA-Z]([a-zA-Z]([0-9]([0-9]([0-9]([0-9]([0-9]([0-9]([0-9]([0-9]([0-9]([0-9]([0-9]([0-9]([0-9])?)?)?)?)?)?)?)?)?)?)?)?)?)?)?$/;

    const email_regex =
      /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    setErrorChange( { newValue, name } );

     if ( name === "ALTERNATE_MOB" ) {
    
        if ( newValue?.length > 10 || newValue?.length < 10 ) {
          setErrors( ( prev ) => ( {
            ...prev,
            ALTERNATE_MOB: {
              errorText: "Invalid Emergency Contact No.",
              errorValue: true,
            },
          } ) );
          // setAlternateErr("Invalid Alternate mob no.");
        } else {
          setErrors( ( prev ) => ( {
            ...prev,
            ALTERNATE_MOB: { errorText: "", errorValue: false },
          } ) );
        }
      
    }
   
   
   
    if ( name === "AADHAR_NUMBER" ) {
      if ( newValue.length === 12 || newValue?.length === 0 ) {
        setErrors( ( prev ) => ( {
          ...prev,
          AADHAR_NUMBER: { errorText: "", errorValue: false },
        } ) );
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          AADHAR_NUMBER: {
            errorText: "Invaild Aadhar Number",
            errorValue: true,
          },
        } ) );
      }
    }
   
    

    if ( name === "PAN_CARD" ) {
      if ( !PAN_regexp.test( newValue ) || newValue.length !== 10 ) {
        setErrors( ( prev ) => ( {
          ...prev,
          PAN_CARD: { errorText: "Invalid PAN Number", errorValue: true },
        } ) );
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          PAN_CARD: { errorText: "", errorValue: false },
        } ) );
      }
    }

    if ( name === "BNK_CON_ACCNT_NO" ) {
      if ( newValue !== fieldValues.BNK_ACCNT_NO ) {
        setErrors( ( prev ) => ( {
          ...prev,
          BNK_CON_ACCNT_NO: {
            errorText: "Confirm Account Number is not matching",
            errorValue: true,
          },
        } ) );
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          BNK_CON_ACCNT_NO: { errorText: " ", errorValue: false },
        } ) );
      }
    }

    if ( name === "IFSC" ) {
      if ( newValue ) {
        if ( !Ifsc.test( newValue ) ) {
          setErrors( ( prev ) => ( {
            ...prev,
            IFSC: {
              errorText: "Invalid IFSC Code",
              errorValue: true,
            },
          } ) );
        } else {
          setErrors( ( prev ) => ( {
            ...prev,
            IFSC: { errorText: " ", errorValue: false },
          } ) );
        }
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          IFSC: { errorText: " ", errorValue: false },
        } ) );
      }
    }

    if ( name === "DRIVING_LICENCE" ) {
      if ( !Driving_regexp.test( newValue ) ) {
        setErrors( ( prev ) => ( {
          ...prev,
          DRIVING_LICENCE: {
            errorText: "Invalid Driving Licence ",
            errorValue: true,
          },
        } ) );
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          DRIVING_LICENCE: { errorText: "", errorValue: false },
        } ) );
      }
    }

     if ( name === "EMAIL" ) {
      if ( !email_regex.test( newValue ) ) {
        setErrors( ( prev ) => ( {
          ...prev,
          EMAIL: { errorText: "Invalid Email ID", errorValue: true },
        } ) );
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          EMAIL: { errorText: " ", errorValue: false },
        } ) );
      }
    }

    // if (name === "PIN_CODE") {
    //   if (value) {
    //     if (value?.length !== 6) {
    //       setErrors((prev) => ({
    //         ...prev,
    //         PIN_CODE: { errorText: "Invalid Pin Code", errorValue: true },
    //       }));
    //     } else {
    //       setErrors((prev) => ({
    //         ...prev,
    //         PIN_CODE: { errorText: " ", errorValue: false },
    //       }));
    //     }
    //   } else {
    //     setErrors((prev) => ({
    //       ...prev,
    //       PIN_CODE: { errorText: " ", errorValue: false },
    //     }));
    //   }
    // }

    if ( name === "PIN_CODE" ) {
      if ( newValue ) {
        validateField( "PIN_CODE", newValue );
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          PIN_CODE: { errorText: "", errorValue: false },
        } ) );
      }
    }

    if ( name === "BNK_POSTAL_CODE" ) {
      if ( newValue ) {
        validateField( "BNK_POSTAL_CODE", newValue );
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          BNK_POSTAL_CODE: { errorText: "", errorValue: false },
        } ) );
      }
    }

    if ( name === "FIRST_NAME" ) {
      if ( newValue ) {
        if ( newValue?.length > 25 ) {
          setErrors( ( prev ) => ( {
            ...prev,
            FIRST_NAME: {
              errorText: "Field length should not be more than 25 chars",
              errorValue: true,
            },
          } ) );
        } else if ( newValue?.length < 3 ) {
          setErrors( ( prev ) => ( {
            ...prev,
            FIRST_NAME: {
              errorText: "Field length should not be less than 3 chars",
              errorValue: true,
            },
          } ) );
        } else {
          setErrors( ( prev ) => ( {
            ...prev,
            FIRST_NAME: { errorText: "", errorValue: false },
          } ) );
        }
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          FIRST_NAME: { errorText: "", errorValue: false },
        } ) );
      }
    }

    if ( name === "MIDDLE_NAME" ) {
      if ( newValue ) {
        if ( newValue?.length > 25 ) {
          setErrors( ( prev ) => ( {
            ...prev,
            MIDDLE_NAME: {
              errorText: "Field length should not be more than 25 chars",
              errorValue: true,
            },
          } ) );
        } else if ( newValue?.length < 3 ) {
          setErrors( ( prev ) => ( {
            ...prev,
            MIDDLE_NAME: {
              errorText: "Field length should not be less than 3 chars",
              errorValue: true,
            },
          } ) );
        } else {
          setErrors( ( prev ) => ( {
            ...prev,
            MIDDLE_NAME: { errorText: "", errorValue: false },
          } ) );
        }
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          MIDDLE_NAME: { errorText: "", errorValue: false },
        } ) );
      }
    }

    if ( name === "LAST_NAME" ) {
      if ( newValue ) {
        if ( newValue?.length > 25 ) {
          setErrors( ( prev ) => ( {
            ...prev,
            LAST_NAME: {
              errorText: "Field length should not be more than 25 chars",
              errorValue: true,
            },
          } ) );
        } else if ( newValue?.length < 3 ) {
          setErrors( ( prev ) => ( {
            ...prev,
            LAST_NAME: {
              errorText: "Field length should not be less than 3 chars",
              errorValue: true,
            },
          } ) );
        } else {
          setErrors( ( prev ) => ( {
            ...prev,
            LAST_NAME: { errorText: "", errorValue: false },
          } ) );
        }
      } else {
        setErrors( ( prev ) => ( {
          ...prev,
          LAST_NAME: { errorText: "", errorValue: false },
        } ) );
      }
    }

    // if (name === "ALTERNATE_MOB") {
    //   if (value === window.sessionStorage.getItem("Mobile_No")) {
    //     setErrors((prev) => ({ ...prev, ALTERNATE_MOB: true }));
    //   }else{
    //     setErrors((prev) => ({ ...prev, ALTERNATE_MOB: false }));
    //   }
    // }

    setFieldValues( { ...fieldValues, [ name ]: newValue } );
  };

  var handleSelectInputs = ( e, values, name ) => {
    if ( name === "GENDER" ) {
      setUserGender( values?.value );
    }
    if ( name === "MARITAL_STATUS" ) {
      let val = ~~values?.value;
      setMaritalStatus( val );
    }
    // const {value} = e.target
    setFieldValues( { ...fieldValues, [ name ]: values } );
  };

  // handle onSelect function to select the values

  const handleMultipleSelectInputs = ( e, values, rowId, id, title, name ) => {
    setMultipleData( { id, rowId, title, name, values } );
    // console.log(values, title);
    if ( title === "Previous Employer Details" ) {
      if ( EmployerList ) {
        if ( values ) {
          EmployerList[ rowId - 1 ].array[ id - 1 ].error = undefined;
          EmployerList[ rowId - 1 ].array[ id - 1 ].value = values?.value;
        }
      }
    } else {
      if ( EducationList ) {
        if ( values ) {
          EducationList[ rowId - 1 ].array[ id - 1 ].error = undefined;
          EducationList[ rowId - 1 ].array[ id - 1 ].value = values?.value;
          // setDynamicTextField([...dynamicTextField]);
        }
        if ( EducationList ) {
          if ( name === "EDUCATION" ) {
            EducationList[ rowId - 1 ].array[ 1 ].options = Certificate?.filter(
              ( val ) => val.code === values?.value
            )?.map( ( itm ) => {
              return {
                id: itm?.Certificate,
                title: itm?.Certificate_text,
                value: itm?.Certificate,
              };
            } );
          }
        }
         if (EducationList) {
          if (name === "EDUCATION") {
            EducationList[rowId - 1].array[5].options = Branch?.filter(
              (val) => val.SLART === values?.value
            )?.map((itm) => {
              return {
                id: itm?.INDEX,
                title: itm?.FTEXT,
                value: itm?.FAART,
              };
            });
          }
        }
      }
    }

    // setFieldValues({ ...fieldValues, [name]: values });
    // console.log(EducationList);
    // console.log(EmployerList);
  };

  useMemo( () => {
    // it is updating Education list
  }, [ multipleData ] );
  // submit all the data

  // handle submit function to submit the data

  const handleSubmitUserDetails = async ( res ) => {
    try {
      await axios.post(
        `${ getURLS().sapApiURL }`,
        res?.data,
        {
          headers: {
            "X-REQUESTED-WITH": "X",
          },
        }
      );

      toast.success( "Data Submitted Successfully!" );
      navigate( '/' )
      setToken( "" );
      setTimeout( () => {
        window.location.reload();
      }, 500 );
    } catch ( error ) {
      toast.error( "Error while submitting the data" );
    } finally {
      setSubmitLoading( false );
    }
  };

  const handleFinalSubmitData = () => {
    if ( !fieldValues?.AADHAR_NUMBER && !fieldValues?.PAN_CARD ) {
      toast.error( "Aadhaar or PAN Number is Required" );
      setErrors( ( prev ) => ( {
        ...prev,
        AADHAR_NUMBER: true,
        PAN_CARD: true,
      } ) );
      return 0;
    }

     if (!fieldValues?.ALTERNATE_MOB) {
      toast.error("Emergency Contact No is Required");
      setErrors((prev) => ({
        ...prev,
        ALTERNATE_MOB: true,
      }));
      return 0;
    }

    if (!fieldValues?.FIRST_NAME) {
      toast.error("First Name is Required");
      setErrors((prev) => ({
        ...prev,
        FIRST_NAME: { errorText: "First Name is required", errorValue: true },
      } ) );
      return 0;
    }

    if ( !fieldValues?.LAST_NAME ) {
      toast.error( "Last Name is Required" );
      setErrors( ( prev ) => ( {
        ...prev,
        LAST_NAME: { errorText: "Last Name is required", errorValue: true },
      } ) );
      return 0;
    }

    if ( !fieldValues?.DOB ) {
      toast.error( "Date of Birth is Required" );
      setErrors( ( prev ) => ( { ...prev, DOB: true } ) );
      return 0;
    }

    if ( !fieldValues?.GENDER ) {
      toast.error( "Gender is Required" );
      setErrors( ( prev ) => ( { ...prev, GENDER: true } ) );
      return 0;
    }

     if (!fieldValues?.MARITAL_STATUS) {
      toast.error("Marital Status is Required");
      setErrors((prev) => ({ ...prev, MARITAL_STATUS: true }));
      return 0;
    }

    // if (!fieldValues?.BNK_ACCNT_NO) {
    //   toast.error("Account Number is Required");
    //   setErrors((prev) => ({ ...prev, BNK_ACCNT_NO: true }));
    //   return 0;
    // }

    if ( fieldValues?.BNK_ACCNT_NO !== fieldValues?.BNK_CON_ACCNT_NO ) {
      toast.error( "Confirm Bank Account Number is Incorrect" );
      setErrors( ( prev ) => ( { ...prev, BNK_CON_ACCNT_NO: true } ) );
      return 0;
    }

    //  if (!fieldValues?.BNK_NAME) {
    //   toast.error("Bank Name is Required");
    //   setErrors((prev) => ({ ...prev, BNK_NAME: true }));
    //   return 0;
    // }

    //  if (!fieldValues?.IFSC) {
    //   toast.error("IFSC Code is Required");
    //   setErrors((prev) => ({ ...prev, IFSC: true }));
    //   return 0;
    // }

    //  if (!fieldValues?.BNK_POSTAL_CODE) {
    //   toast.error("Postal Code is Required");
    //   setErrors((prev) => ({ ...prev, BNK_POSTAL_CODE: true }));
    //   return 0;
    // }

    // console.log("EducationList", EducationList);
    if (
      EducationList?.some( ( val ) =>
        val?.array?.some(
          ( itm ) =>
            itm?.name === "EDUCATION" && ( !itm?.value || itm?.value === "" )
        )
      )
    ) {
      toast.error( "Education is Required" );
      setErrors( ( prev ) => ( { ...prev, EDUCATION: true } ) );
      return 0;
    }

    if (
      EducationList?.some( ( val ) =>
        val?.array?.some(
          ( itm ) =>
            itm?.name === "EDU_CERTIFICATE" &&
            ( !itm?.value || itm?.value === "" )
        )
      )
    ) {
      toast.error( "Certificate is Required" );
      setErrors( ( prev ) => ( { ...prev, EDU_CERTIFICATE: true } ) );
      return 0;
    }

    // if (
    //   EducationList?.some((val) =>
    //     val?.array?.some(
    //       (itm) =>
    //         itm?.name === "EDU_COUNTRY" && (!itm?.value || itm?.value === "")
    //     )
    //   )
    // ) {
    //   toast.error("Education Country is Required");
    //   setErrors((prev) => ({ ...prev, EDU_COUNTRY: true }));
    //   return 0;
    // }

    if (
      EducationList?.some( ( val ) =>
        val?.array?.some(
          ( itm ) =>
            itm?.name === "EDU_INSTITUTE" && ( !itm?.value || itm?.value === "" )
        )
      )
    ) {
      toast.error( "Institute is Required" );
      setErrors( ( prev ) => ( { ...prev, EDU_INSTITUTE: true } ) );
      return 0;
    }

    // if (
    //   EducationList?.some((val) =>
    //     val?.array?.some(
    //       (itm) =>
    //         itm?.name === "EDU_TYPE" && (!itm?.value || itm?.value === "")
    //     )
    //   )
    // ) {
    //   toast.error("Education Type is Required");
    //   setErrors((prev) => ({ ...prev, EDU_TYPE: true }));
    //   return 0;
    // }

    const eduData = EducationList?.map( ( val ) => val.array );
    const empData = EmployerList?.map( ( val ) => val.array );
    setSubmitLoading( true );
    axios
      .post(
        `${ getURLS().tempBaseURL }/users_details`,
        // "http://localhost:8080/api/users_details",
        {
          AADHAR_NUMBER: fieldValues?.AADHAR_NUMBER,
          PAN_CARD: fieldValues?.PAN_CARD,
          SUB_DATE: fieldValues?.SUB_DATE,
          DRIVING_LICENCE: fieldValues?.DRIVING_LICENCE,
          LICENCE_TYPE: fieldValues?.LICENCE_TYPE?.value,
          MOB_NO: token,
          ALTERNATE_MOB: fieldValues?.ALTERNATE_MOB,
          EMAIL: fieldValues?.EMAIL,
          FIRST_NAME: fieldValues?.FIRST_NAME,
          MIDDLE_NAME: fieldValues?.MIDDLE_NAME,
          LAST_NAME: fieldValues?.LAST_NAME,
          GENDER: fieldValues?.GENDER?.value,
          BLOOD_GROUP: fieldValues?.BLOOD_GROUP?.value,
          CATEGORY: fieldValues?.CATEGORY?.value,
          DOB: fieldValues?.DOB?.replaceAll( "-", "" ),
          ADDRESS: fieldValues?.ADDRESS,
          PLACE: fieldValues?.PLACE,
          STATE: fieldValues?.STATE,
          COUNTRY: "IN",
          PIN_CODE: fieldValues?.PIN_CODE,
          NATIONALITY: "IN",
          MARITAL_STATUS: fieldValues?.MARITAL_STATUS?.value,
          MARRIAGE_DATE: fieldValues?.MARRIAGE_DATE?.replaceAll( "-", "" ),
          SPOUSE_NAME: fieldValues?.SPOUSE_NAME,
          SPOUSE_GENDER: fieldValues?.SPOUSE_GENDER?.value,
          SPOUSE_DOB: fieldValues?.SPOUSE_DOB?.replaceAll( "-", "" ),
          RELIGION: fieldValues?.RELIGION?.value,
          QUALIFICATION: fieldValues?.QUALIFICATION,
          BNK_ACCNT_NO: fieldValues?.BNK_ACCNT_NO,
          BNK_CON_ACCNT_NO: fieldValues?.BNK_ACCNT_NO && fieldValues?.BNK_CON_ACCNT_NO,
          BNK_POSTAL_CODE: fieldValues?.BNK_POSTAL_CODE,
          PURPOSE: fieldValues?.PURPOSE,
          BNK_NAME: fieldValues?.BNK_NAME,
          BNK_IFSC: fieldValues?.IFSC,
          BNK_CITY: fieldValues?.BNK_CITY,
          BNK_ACC_HOL_NAME: fieldValues?.FIRST_NAME,
          ET_EMP_EMPLOYERSet: empData?.map( ( val, index ) => {
            return {
              AADHAR_NUMBER: fieldValues?.AADHAR_NUMBER || "",
              EMPLOYER: val[ 0 ]?.value || "",
              EMPLOYER_CITY: val[ 1 ]?.value || "",
              EMPLOYER_COUNTRY: "IN",
              EMPLOYER_INDUSTRY: val[ 2 ]?.value || "",
              EMPLOYEE_JOB: val[ 3 ]?.value || "",
              WORK_CONTRACT: val[ 4 ]?.value || "",
              ANNUAL_SALARY: val[ 5 ]?.value || "",
              // CURRENCY: val[7]?.value || "",
              EXPERIENCE_TYPE: val[ 6 ]?.value || "",
              JOB_ROLE: val[ 7 ]?.value || "",
              EMPLOYER_START_DATE: val[ 8 ]?.value?.replaceAll( "-", "" ),
              EMPLOYER_END_DATE: val[ 9 ]?.value?.replaceAll( "-", "" ),
            };
          } ),
          ET_EMP_EDUCATIONSet: eduData?.map( ( val, index ) => {
            return {
              AADHAR_NUMBER: fieldValues?.AADHAR_NUMBER || "",
              EDUCATION: val[ 0 ]?.value || "",
              EDU_CERTIFICATE: val[ 1 ]?.value || "",
              EDU_COUNTRY: "IN",
              EDU_FINAL_GRADE: val[ 2 ]?.value || "",
              EDU_TYPE: val[ 7 ]?.value || "",
              EDU_BRANCH: val[ 5 ]?.value || "",
              EDU_PERCENTAGE: val[ 6 ]?.value || "",
              EDU_INSTITUTE: val[ 3 ]?.value || "",
              EDU_OTH_INSTITUTE: val[ 4 ]?.value || "",
              EDU_START_DATE: val[ 8 ]?.value?.replaceAll( "-", "" ),
              EDU_END_DATE: val[ 9 ]?.value?.replaceAll( "-", "" ),
            };
          } ),
        },

        {
          headers: {
            "X-REQUESTED-WITH": "X",
          },
        }
      )
      .then( ( res ) => {
        if ( res?.data ) {
          delete res?.data?.id;
        }
        handleSubmitUserDetails( res );
        setTimeLeft( 0 );
        setCanResend( false );
        setOtpFieldVisible( false );
      } )
      .catch( ( err ) => {
        toast.error( err?.message || "There is an Error" );
      } )
  };


  const MandatoryFields = [
    {
      id: 1,
      title: "Aadhaar Card No",
      name: "AADHAR_NUMBER",
      value: fieldValues.AADHAR_NUMBER,
      type: "number",
      required: !fieldValues?.PAN_CARD && true,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.AADHAR_NUMBER?.errorValue,
      errorText: errors?.AADHAR_NUMBER?.errorText,
    },
    {
      id: 2,
      title: "PAN Card No",
      name: "PAN_CARD",
      type: "text",
      value: fieldValues?.PAN_CARD,
      required: !fieldValues?.AADHAR_NUMBER && true,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors.PAN_CARD?.errorValue,
      errorText: errors.PAN_CARD?.errorText,
    },
    {
      id: 3,
      title: "Licence type",
      name: "LICENCE_TYPE",
      type: "select",
      value: fieldValues?.LICENCE_TYPE,
      options: [
        { id: 1, title: "None", value: "" },
        { id: 2, title: "Two-Wheeler", value: "1" },
        { id: 3, title: "Four-Wheeler", value: "2" },
        { id: 4, title: "Heavy Vehicle", value: "3" },

      ],
      required: false,
      handleFunction: handleSelectInputs,
      Component: SelectInput,
      error: errors.LICENCE_TYPE.errorValue,
      errorText: errors.LICENCE_TYPE.errorText,
    },
    {
      id: 4,
      title: "Driving Licence No",
      name: "DRIVING_LICENCE",
      type: "text",
      value: fieldValues?.DRIVING_LICENCE,
      required: false,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors.DRIVING_LICENCE?.errorValue,
      errorText: errors.DRIVING_LICENCE?.errorText,
    },
    {
      id: 5,
      title: "Mobile No",
      name: "MOB_NO",
      type: "number",
      value: token,
      required: true,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.MOB_NO,
      disabled: true,
      errorText: errors.MOB_NO.errorValue,
      startIcon: "Mob No.",
    },
    {
      id: 6,
      title: "Emergency Contact No",
      name: "ALTERNATE_MOB",
      type: "number",
      required:true,
      value: fieldValues?.ALTERNATE_MOB,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.ALTERNATE_MOB.errorValue,
      errorText: errors.ALTERNATE_MOB.errorText,
      startIcon: "Mob No.",
    },
    {
      id: 7,
      title: "E-mail Id",
      name: "EMAIL",
      type: "text",
      value: fieldValues?.EMAIL,
      required: false,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.EMAIL.errorValue,
      errorText: errors.EMAIL.errorText,
    },
  ];

  const CommunicationDetails = [
    {
      id: 1,
      title: "Address",
      name: "ADDRESS",
      value: fieldValues?.ADDRESS,
      type: "text",
      required: true,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors.ADDRESS.errorValue,
      errorText: errors.ADDRESS.errorText,
    },
    // {
    //   id: 2,
    //   title: "Taluka",
    //   name: "TALUKA",
    //   value: fieldValues?.TALUKA,
    //   type: "text",
    //   required: false,
    //   handleFunction: handleGetInputs,
    //   Component: TextInput,
    //   error: errors.TALUKA,
    //   errorText: "The length must be more than 3 chars and less than 50 chars",
    // },
    {
      id: 2,
      title: "Pincode",
      name: "PIN_CODE",
      value: fieldValues?.PIN_CODE,
      type: "number",
      required: true,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.PIN_CODE.errorValue,
      errorText: errors?.PIN_CODE.errorText,
    },
    {
      id: 3,
      title: "District",
      name: "PLACE",
      value: fieldValues?.PLACE,
      type: "text",
      required: true,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors.PLACE.errorValue,
      errorText: errors.PLACE.errorText,
    },
    {
      id: 4,
      title: "State",
      name: "STATE",
      type: "text",
      value: fieldValues?.STATE,
      // options: [
      //   { id: 1, title: "Maharashatra", value: "maharashatra" },
      //   { id: 2, title: "Others", value: "others" },
      // ],
      required: true,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors.STATE.errorValue,
      errorText: errors.STATE.errorText,
    },
    // {
    //   id: 5,
    //   title: "Country",
    //   name: "COUNTRY",
    //   type: "select",
    //   value: fieldValues?.COUNTRY,
    //   options: [{ id: 1, title: "India", value: "IN" }],
    //   required: false,
    //   handleFunction: handleSelectInputs,
    //   Component: SelectInput,
    //   error: errors.COUNTRY.errorValue,
    //   errorText: errors.COUNTRY.errorText,
    // },
  ];

  const EmployeeDetailsFields = [
    {
      id: 1,
      title: "First Name",
      name: "FIRST_NAME",
      value: fieldValues?.FIRST_NAME,
      type: "text",
      required: true,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors.FIRST_NAME.errorValue,
      errorText: errors.FIRST_NAME.errorText,
    },
    {
      id: 2,
      title: "Middle Name",
      name: "MIDDLE_NAME",
      value: fieldValues?.MIDDLE_NAME,
      type: "text",
      required: false,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors.MIDDLE_NAME.errorValue,
      errorText: errors.MIDDLE_NAME.errorText,
    },

    {
      id: 3,
      title: "Last Name",
      name: "LAST_NAME",
      type: "text",
      value: fieldValues?.LAST_NAME,
      required: true,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors.LAST_NAME.errorValue,
      errorText: errors.LAST_NAME.errorText,
    },
    {
      id: 4,
      title: "Date of Birth",
      name: "DOB",
      type: "date",
      value: fieldValues?.DOB,
      required: true,
      handleFunction: handleGetdates,
      Component: DateInput,
      error: errors.DOB.errorValue,
      errorText: errors.DOB.errorText,
    },
    {
      id: 5,
      title: "Gender",
      name: "GENDER",
      type: "select",
      value: fieldValues?.GENDER,
      options: [
        { id: 1, title: "Male", value: "1" },
        { id: 2, title: "Female", value: "2" },
        { id: 3, title: "Transgender", value: "3" },
      ],
      required: true,
      handleFunction: handleSelectInputs,
      Component: SelectInput,
      error: errors.GENDER.errorValue,
      errorText: errors.GENDER.errorText,
    },
    {
      id: 6,
      title: "Blood Group",
      name: "BLOOD_GROUP",
      type: "text",
      value: fieldValues?.BLOOD_GROUP,
      required: false,
      options: [
        { id: 1, title: "O +Ve", value: "O+" },
        { id: 2, title: "O -VE", value: "O-" },
        { id: 3, title: "AB +VE", value: "AB+" },
        { id: 4, title: "AB -VE", value: "AB-" },
        { id: 5, title: "A +VE", value: "A+" },
        { id: 6, title: "A -VE", value: "A-" },
        { id: 7, title: "B +VE", value: "B+" },
        { id: 8, title: "B -VE", value: "B-" },
      ],
      handleFunction: handleSelectInputs,
      Component: SelectInput,
      error: errors.BLOOD_GROUP.errorValue,
      errorText: errors.BLOOD_GROUP.errorText,
    },
    {
      id: 7,
      title: "Marital Status",
      name: "MARITAL_STATUS",
      type: "select",
      value: fieldValues?.MARITAL_STATUS,
      // defaultValue: fieldValues?.marital_status,
      options: [
        { id: 1, title: "Single", value: "0" },
        { id: 2, title: "Married", value: "1" },
        { id: 3, title: "Divorced", value: "3" },
        { id: 4, title: "Separated", value: "5" },
        { id: 5, title: "Widow", value: "2" },
        { id: 6, title: "Widowr", value: "7" },
        { id: 7, title: 'R-Part', value: '8' }

      ],
      required: true,
      handleFunction: handleSelectInputs,
      Component: SelectInput,
      error: errors.MARITAL_STATUS.errorValue,
      errorText: errors.MARITAL_STATUS.errorText,
    },
    {
      id: 8,
      title: "Date of Marriage",
      name: "MARRIAGE_DATE",
      type: "date",
      value: fieldValues?.MARRIAGE_DATE,
      required: false,
      handleFunction: handleGetdates,
      Component: DateInput,
      error: errors.MARRIAGE_DATE.errorValue,
      errorText: errors.MARRIAGE_DATE.errorText,
      disabled: maritalStatus === 0 && true,
    },
    {
      id: 9,
      title: userGender === "1" ? "Father's Name" : "Spouse Name",
      name: "SPOUSE_NAME",
      type: "text",
      value: fieldValues?.SPOUSE_NAME,
      required: false,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors.SPOUSE_NAME.errorValue,
      errorText: errors.SPOUSE_NAME.errorText,
      disabled: maritalStatus === 0 && true,
    },
    {
      id: 10,
      title:
        userGender === "1" ? "Father's Date of Birth" : "Spouse Date of Birth",
      name: "SPOUSE_DOB",
      type: "date",
      value: fieldValues?.SPOUSE_DOB,
      required: false,
      handleFunction: handleGetdates,
      Component: DateInput,
      error: errors.SPOUSE_DOB.errorValue,
      errorText: errors.SPOUSE_DOB.errorText,
      disabled: maritalStatus === 0 && true,
    },
    {
      id: 11,
      title: userGender === "1" ? "Gender" : "Spouse Gender",
      name: "SPOUSE_GENDER",
      type: "select",
      value: fieldValues?.SPOUSE_GENDER,
      options:
        userGender === "1"
          ? [ { id: 1, title: "Male", value: "1" } ]
          : [
            { id: 1, title: "Male", value: "1" },
            { id: 2, title: "Female", value: "2" },
            { id: 3, title: "Transgender", value: "3" },
          ],
      required: false,
      handleFunction: handleSelectInputs,
      Component: SelectInput,
      error: errors.SPOUSE_GENDER.errorValue,
      errorText: errors.SPOUSE_GENDER.errorText,
      disabled: maritalStatus === 0 && true,
    },
    {
      id: 12,
      title: "Caste",
      name: "CATEGORY",
      type: "select",
      value: fieldValues?.CATEGORY,
      options: [
        { id: 1, title: "General", value: "1" },
        { id: 2, title: "Other Backward Class", value: "6" },
        { id: 3, title: "Nomadic Tribe", value: "4" },
        { id: 4, title: "Backward Class", value: "5" },
        { id: 5, title: "Scheduled Class", value: "2" },
        { id: 6, title: "Scheduled Tribe", value: "3" },
      ],
      required: false,
      handleFunction: handleSelectInputs,
      Component: SelectInput,
      error: errors.CATEGORY.errorValue,
      errorText: errors.CATEGORY.errorText,
      // disabled: maritalStatus === 1 && true,
    },
    // {
    //   id: 13,
    //   title: "Nationality",
    //   name: "NATIONALITY",
    //   type: "select",
    //   defaultValue:"IN",
    //   value: "IN",
    //   options: [{ id: 1, title: "India", value: "IN" }],
    //   required: false,
    //   handleFunction: handleSelectInputs,
    //   Component: SelectInput,
    //   error: errors.NATIONALITY.errorValue,
    //   errorText: errors.NATIONALITY.errorText,
    //   // disabled: maritalStatus === 1 && true,
    // },
    {
      id: 13,
      title: "Religion",
      name: "RELIGION",
      value: fieldValues?.RELIGION,
      type: "select",
      options: ReligionList,
      required: false,
      handleFunction: handleSelectInputs,
      Component: SelectInput,
      error: errors.RELIGION.errorValue,
      errorText: errors.RELIGION.errorText,
      // disabled: maritalStatus === 1 && true,
    },
  ];
  const EducationDetails = [
    {
      id: 1,
      title: "Education",
      name: "EDUCATION",
      value: undefined,
      options: [
        {
          id: 1,
          title: "High School",
          value: "01",
        },
        {
          id: 2,
          title: "Higher Secondary Sch",
          value: "02",
        },
        {
          id: 3,
          title: "ITI",
          value: "03",
        },
        {
          id: 4,
          title: "Diploma",
          value: "04",
        },
        {
          id: 5,
          title: "Graduation",
          value: "05",
        },
        {
          id: 6,
          title: "Professional Degree",
          value: "06",
        },
        {
          id: 7,
          title: "Post Graduation",
          value: "07",
        },
        {
          id: 8,
          title: "PG Diploma",
          value: "08",
        },
        {
          id: 9,
          title: "Professional Certification",
          value: "09",
        },
        {
          id: 10,
          title: "Doctoral Certification",
          value: "10",
        },
        {
          id: 11,
          title: "Post Diploma",
          value: "11",
        },
      ],
      type: "select",
      required: true,

      // handleFunction: handleSelectInputs,
      Component: SelectInput,
      error: errors?.EDUCATION.errorValue,
      errorText: errors?.EDUCATION.errorText,
    },
    {
      id: 2,
      title: "Certificate",
      name: "EDU_CERTIFICATE",
      value: undefined,
      type: "select",
      required: true,
      options: [],
      // handleFunction: handleGetInputs,
      Component: SelectInput,
      error: errors?.EDU_CERTIFICATE.errorValue,
      errorText: errors?.EDU_CERTIFICATE.errorText,
    },
    // {
    //   id: 3,
    //   title: "Education Country",
    //   name: "EDU_COUNTRY",
    //   value: undefined,
    //   type: "select",
    //   required: true,
    //   options: [{ id: 1, title: "India", value: "IN" }],
    //   // handleFunction: handleGetInputs,
    //   Component: SelectInput,
    //   error: errors?.EDU_COUNTRY.errorValue,
    //   errorText: errors?.EDU_COUNTRY.errorText,
    // },

    {
      id: 3,
      title: "Final Grade",
      name: "EDU_FINAL_GRADE",
      value: undefined,
      type: "select",
      required: false,
      // handleFunction: handleGetInputs,
      options: [
        { id: 1, title: "A+", value: "A+" },
        { id: 2, title: "A", value: "A" },
        { id: 3, title: "A-", value: "A-" },
        { id: 4, title: "B+", value: "B+" },
        { id: 5, title: "B", value: "B" },
        { id: 6, title: "B-", value: "B-" },
        { id: 7, title: "C+", value: "C+" },
        { id: 8, title: "C", value: "C" },
        { id: 9, title: "C-", value: "C-" },
        { id: 10, title: "D+", value: "D+" },
        { id: 11, title: "D", value: "D" },
        { id: 12, title: "D-", value: "D-" },
        { id: 13, title: "F", value: "F" },
      ],
      Component: SelectInput,
      error: errors?.EDU_FINAL_GRADE.errorValue,
      errorText: errors?.EDU_FINAL_GRADE.errorText,
    },
    {
      id: 4,
      title: "Institute",
      name: "EDU_INSTITUTE",
      value: undefined,
      type: "select",
      required: true,
      options: Institute?.map( ( val ) => {
        return { title: val?._2, value: val?._1 };
      } ),
      // handleFunction: handleGetInputs,
      Component: SelectInput,
      error: errors?.EDU_INSTITUTE.errorValue,
      errorText: errors?.EDU_INSTITUTE.errorText,
    },
    {
      id: 5,
      title: "Other Institute Name(optional)",
      name: "EDU_OTH_INSTITUTE",
      value: undefined,
      type: "text",
      required: false,
      disabld: true,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.EDU_OTH_INSTITUTE.errorValue,
      errorText: errors.EDU_OTH_INSTITUTE.errorText,
    },
    {
      id: 6,
      title: "Branch of Study/Trade",
      name: "EDU_BRANCH",
      value: undefined,
      type: "select",
      required: false,
       options: [],
      // handleFunction: handleGetInputs,
      Component: SelectInput,
      error: errors?.EDU_BRANCH.errorValue,
      errorText: errors?.EDU_BRANCH.errorText,
    },
    {
      id: 7,
      title: "Percentage of Marks",
      name: "EDU_PERCENTAGE",
      value: undefined,
      type: "number",
      required: false,
      // handleFunction: handleGetInputs,
      Component: TextInput,
      endIcon: "%",
      error: errors?.EDU_PERCENTAGE.errorValue,
      errorText: errors?.EDU_PERCENTAGE.errorText,
    },
    {
      id: 8,
      title: "Education type",
      name: "EDU_TYPE",
      value: undefined,
      type: "select",
      options: [
        {
          id: 1,
          title: "Full time",
          value: "1",
        },
        {
          id: 2,
          title: "Part time",
          value: "2",
        },
      ],
      required: false,
      // handleFunction: handleSelectInputs,
      Component: SelectInput,
      error: errors?.EDU_TYPE.errorValue,
      errorText: errors?.EDU_TYPE.errorText,
    },

    {
      id: 9,
      title: "Start Date",
      name: "EDU_START_DATE",
      value: undefined,
      type: "date",
      required: false,
      // handleFunction: handleGetInputs,
      Component: DateInput,
      dynamicDate: true,
      error: errors?.EDU_START_DATE.errorValue,
      errorText: errors?.EDU_START_DATE.errorText,
    },
    {
      id: 10,
      title: "End Date",
      name: "EDU_END_DATE",
      value: undefined,
      type: "date",
      required: false,
      handleFunction: handleDynamicDates,
      Component: DateInput,
      error: errors?.EDU_END_DATE.errorValue,
      errorText: errors?.EDU_END_DATE.errorText,
    },
  ];

  const EmployerFields = [
    {
      id: 1,
      title: "Employer",
      name: "EMPLOYER",
      value: undefined,
      type: "text",
      required: false,
      // handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.EMPLOYER?.errorValue,
      errorText: errors?.EMPLOYER?.errorText,
    },
    {
      id: 2,
      title: "City",
      name: "EMPLOYER_CITY",
      value: undefined,
      type: "text",
      required: false,
      // handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.EMPLOYER_CITY?.errorValue,
      errorText: errors?.EMPLOYER_CITY?.errorText,
    },
    // {
    //   id: 3,
    //   title: "Country",
    //   name: "EMPLOYER_COUNTRY",
    //   value: undefined,
    //   type: "select",
    //   required: false,
    //   // handleFunction: handleGetInputs,
    //   options: [{ id: 1, title: "India", value: "IN" }],
    //   Component: SelectInput,
    //   error: errors?.EMPLOYER_COUNTRY?.errorValue,
    //   errorText: errors?.EMPLOYER_COUNTRY?.errorText,
    // },
    {
      id: 3,
      title: "Industry",
      name: "EMPLOYER_INDUSTRY",
      value: undefined,
      type: "select",
      required: false,
      options: IndList,
      Component: SelectInput,
      error: errors?.EMPLOYER_INDUSTRY?.errorValue,
      errorText: errors?.EMPLOYER_INDUSTRY?.errorText,
    },
    {
      id: 4,
      title: "Job",
      name: "JOB",
      value: undefined,
      type: "text",
      required: false,
      // handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.JOB?.errorValue,
      errorText: errors?.JOB?.errorText,
    },
    {
      id: 5,
      title: "Work Contract",
      name: "WORK_CONTRACT",
      value: undefined,
      type: "number",
      required: false,
      // handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.WORK_CONTRACT?.errorValue,
      errorText: errors?.WORK_CONTRACT?.errorText,
      endIcon: "years",
    },
    {
      id: 6,
      title: "Annual gross salary",
      name: "ANNUAL_SALARY",
      value: undefined,
      type: "number",
      required: false,
      // handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.ANNUAL_SALARY?.errorValue,
      errorText: errors?.ANNUAL_SALARY?.errorText,
    },
    {
      id: 7,
      title: "Experience type",
      name: "EXPERIENCE_TYPE",
      value: undefined,
      type: "select",
      required: false,
      options: [
        { id: 1, title: "Relevant", value: "1" },
        { id: 2, title: "Irrelevant", value: "" },
      ],
      // handleFunction: handleGetInputs,
      Component: SelectInput,
      error: errors?.EXPERIENCE_TYPE?.errorValue,
      errorText: errors?.EXPERIENCE_TYPE?.errorText,
    },
    {
      id: 8,
      title: "Role",
      name: "JOB_ROLE",
      value: undefined,
      type: "text",
      required: false,
      // handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.JOB_ROLE?.errorValue,
      errorText: errors?.JOB_ROLE?.errorText,
    },
    {
      id: 9,
      title: "Start Date",
      name: "EMPLOYER_START_DATE",
      value: undefined,
      type: "date",
      required: false,
      // handleFunction: handleGetInputs,
      Component: DateInput,
      dynamicDate: true,
      error: errors?.EMPLOYER_START_DATE?.errorValue,
      errorText: errors?.EMPLOYER_START_DATE?.errorText,
    },
    {
      id: 10,
      title: "End Date",
      name: "EMPLOYER_END_DATE",
      value: undefined,
      type: "date",
      required: false,
      // handleFunction: handleGetInputs,
      Component: DateInput,
      dynamicDate: true,
      error: errors?.EMPLOYER_END_DATE?.errorValue,
      errorText: errors?.EMPLOYER_END_DATE?.errorText,
    },
  ];

  const BankDetails = [
    {
      id: 1,
      title: "Account Number",
      name: "BNK_ACCNT_NO",
      value: fieldValues?.BNK_ACCNT_NO,
      type: "number",
      required: false,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.BNK_ACCNT_NO.errorValue,
      errorText: errors?.BNK_ACCNT_NO.errorText,
    },
    {
      id: 2,
      title: "Confirm Account Number",
      name: "BNK_CON_ACCNT_NO",
      value: fieldValues?.BNK_CON_ACCNT_NO,
      type: "password",
      required: false,
      disabled: !fieldValues?.BNK_ACCNT_NO,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.BNK_CON_ACCNT_NO.errorValue,
      errorText: errors?.BNK_CON_ACCNT_NO.errorText,
    },
    {
      id: 3,
      title: "Account Holder Name",
      name: "BNK_ACC_HOL_NAME",
      value: capitalize( fieldValues?.FIRST_NAME ),
      type: "text",
      required: false,
      disabled: true,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.BNK_ACC_HOL_NAME.errorValue,
      errorText: errors?.BNK_ACC_HOL_NAME.errorText,
    },
    {
      id: 4,
      title: "Bank Name",
      name: "BNK_NAME",
      value: fieldValues?.BNK_NAME,
      type: "text",
      required: false,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.BNK_NAME.errorValue,
      errorText: errors?.BNK_NAME.errorText,
    },

    {
      id: 5,
      title: "IFSC Code",
      name: "IFSC",
      value: fieldValues?.IFSC,
      type: "text",
      required: false,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.IFSC.errorValue,
      errorText: errors?.IFSC.errorText,
    },
    {
      id: 6,
      title: "City",
      name: "BNK_CITY",
      value: fieldValues?.BNK_CITY,
      type: "text",
      required: false,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.BNK_CITY.errorValue,
      errorText: errors?.BNK_CITY.errorText,
    },
    {
      id: 7,
      title: "Pincode",
      name: "BNK_POSTAL_CODE",
      value: fieldValues?.BNK_POSTAL_CODE,
      type: "number",
      required: false,
      handleFunction: handleGetInputs,
      Component: TextInput,
      error: errors?.BNK_POSTAL_CODE.errorValue,
      errorText: errors?.BNK_POSTAL_CODE.errorText,
    },
  ];

  const addNewRow = ( e, key ) => {
    if ( key === "Education Details" ) {
      setEducationList( ( pre ) => [
        ...pre,
        { id: EducationList?.length + 1, array: EducationDetails },
      ] );
    } else {
      setEmployerList( ( pre ) => [
        ...pre,
        { id: EmployerList?.length + 1, array: EmployerFields },
      ] );
    }
  };

  const HandleDeleteRow = ( e, section, index, title ) => {
    const filterEduRows = EducationList?.filter(
      ( EduList ) =>
        EducationList?.indexOf( EduList ) !== EducationList?.indexOf( section )
    );
    const filterEmpRows = EmployerList?.filter(
      ( EduList ) =>
        EmployerList?.indexOf( EduList ) !== EmployerList?.indexOf( section )
    );

    if ( title === "Education Details" ) {
      setEducationList( filterEduRows );
    } else {
      setEmployerList( filterEmpRows );
    }
  };

  return (
    <DataContext.Provider
      value={ {
        fieldValues,
        EmployeeDetailsFields,
        MandatoryFields,
        handleFinalSubmitData,
        CommunicationDetails,
        EmployerFields,
        BankDetails,
        errors,
        addNewRow,
        EducationList,
        handleGetMultipleInputs,
        handleMultipleSelectInputs,
        EmployerList,
        HandleDeleteRow,
        enableError,
        submitLoading,
        token,
        setToken,
        timeLeft,
        setTimeLeft,
        canResend,
        setCanResend,
        otpFieldVisible,
        setOtpFieldVisible,
        handleDynamicDates
      } }
    >
      { children }
    </DataContext.Provider>
  );
}

export default DataProvider;
